import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Injector,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormControlComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzRateModule } from 'ng-zorro-antd/rate';
import {
  FeedBack,
  FeedbackDrawerParams,
  Question,
  FeedBackByCase,
  CaseFeedBackReportResponse,
  PrintFeedBack,
  AdminNoteByFeedback,
} from './feedback';
import {
  finalize,
  firstValueFrom,
  Observable,
  of,
  Subject,
  take,
  takeUntil,
  BehaviorSubject,
  map,
} from 'rxjs';
import { FeedbackService } from './feedback.service';
import { LoaderService } from '../../../../core/services/loader.service';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { DrawerService } from '../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../core/constants/drawer-ids.constant';
import { CommonService } from '../../../../shared/services/common.service';
import { FeedbackFormComponent } from './feedback-form/feedback-form.component';
import { DrawerHeaderComponent } from '../../../../components/drawer-header/drawer-header.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { InsightMode } from '../../insights.enums';
import { AuthService } from '../../../../core/services/auth.service';
import { PrintFeedbackComponent } from './print-feedback/print-feedback.component';
import { OrganizationModel } from '../../../organizations/organization.interface';
import { OrganizationService } from '../../../organizations/organization.service';
import { ErrorResponse } from '../../../../core/models/error.models';
import { InsightsDataService } from '../insights-data/insights-data.service';
import { ManageGraphComponent } from '../insights-data/manage-graph.component';
import { UserDatePipe } from '../../../../shared/pipes/user-date.pipe';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { GraphFilterComponent } from '../insights-data/data-graph/graph-filter/graph-filter.component';
import {
  BehaviorGraphDataResponse,
  CaseBehaviorUnitMapping,
  caseBehaviorUnitMappings,
  frequencyDatasheetGraph,
  frequencyIntervalGraph,
  GraphFilterEvent,
  latencyGraph,
  partialIntervalGraph,
  replacementDataType,
} from '../insights-data/insights-data.interface';
import { format, parse } from 'date-fns';
import { DATE_FORMAT } from './feeback.enum';
import { AuditLogsService } from '../../../audit-logs/audit-logs.service';
import {
  AuditModule,
  AuditOperationType,
} from '../../../audit-logs/audit-logs.constants';
import { ExportedReportItem } from '../../../administration/insights-admin/insights-admin.interface';
import {
  JobStatus,
  JobType,
} from '../../../administration/insights-admin/insights-admin.enums';
import { ReportManagerService } from '../../../administration/insights-admin/report-manager.service';
import { TimeZoneService } from '../../../../core/services/timezone.service';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    NzDividerModule,
    NzFormModule,
    UserDatePipe,
    NzRadioModule,
    NzRateModule,
    FormsModule,
    NzInputModule,
    NzButtonModule,
    CommonModule,
    ReactiveFormsModule,
    NzSpinModule,
    NzTableModule,
    DrawerHeaderComponent,
    SvgIconComponent,
    NzModalModule,
    NzInputModule,
    NzFormControlComponent,
    GraphFilterComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss',
})
export class FeedbackComponent
  extends ManageGraphComponent
  implements OnInit, OnDestroy
{
  private readonly drawerService = inject(DrawerService);
  private readonly feedBackService = inject(FeedbackService);
  feedbackForm: FormGroup;
  insightMode = InsightMode;
  questions: Question[] = [];
  private readonly destroy$ = new Subject<void>();
  pageSize = 10;
  pageIndex = 1;
  total = 0;
  sort = '';
  reportPageSize = 10;
  reportPageIndex = 1;
  reportTotal = 0;
  reportSort = '';
  reportSortOrder: number | undefined = undefined;
  adminNote = '';
  sortOrder: number | undefined = undefined;
  feedbackDetails = {} as FeedbackDrawerParams;
  feedBackHistory$ = this.feedBackService.feedback$;
  hasIncompleteFeedBack = false;
  isFeedBackEditable = false;
  isModalVisible = false;
  reportData: CaseFeedBackReportResponse | null = null;
  loggedInUserId = 0;
  counter = 1;
  printForm!: FormGroup;
  private readonly printLoadingSubject = new BehaviorSubject<
    Record<string, boolean>
  >({});
  datasheetData: { id: number; value: string }[] = [
    { id: 1, value: 'Frequency Based Datasheet' },
    { id: 2, value: 'Latency' },
    { id: 3, value: 'Partial Interval' },
    { id: 4, value: 'Replacement Behavior' },
  ];

  graphImages: string[] = [];
  graphImagesByBehaviorId: Record<string, string[]> = {};
  printLoading$ = this.printLoadingSubject.asObservable();
  listOfColumn = [
    {
      title: 'Member',
      key: 'name',
    },
    {
      title: 'Date & Time',
      key: 'submissionDate',
    },
    {
      title: 'Overall Score',
      key: 'overallScore',
    },
  ];
  notes: AdminNoteByFeedback[] = [];
  isAdminNotesModalVisible = false;
  isNoteModalVisible = false;
  noteForm!: FormGroup;
  isNoteSubmitting = false;
  editingNote: AdminNoteByFeedback | null = null;
  JobStatusEnum = JobStatus;

  loading$: Observable<boolean> = of(false);
  @ViewChild('viewFeedbackFormTpl') viewFeedbackFormTpl!: TemplateRef<void>;
  selectedFeedback: FeedBack | null = null;
  isShowExportManagerDialog = false;
  isShowExportDetailDialog = false;
  exportedReports: ExportedReportItem[] = [];
  reportDetailForm!: FormGroup;
  timeZone = 'UTC';
  checkedOrganization = false;
  indeterminate = false;
  listOfCurrentPageData: readonly FeedBack[] = [];
  setOfCheckedOrgId: number[] = [];
  selectedCase: FeedBack[] = [];
  listOfSelection = [
    {
      text: 'Select All Row',
      onSelect: () => {
        this.onAllChecked(false);
      },
    },
  ];

  constructor(
    private readonly fb: FormBuilder,
    private readonly feedbackService: FeedbackService,
    private readonly loaderService: LoaderService,
    private readonly commonService: CommonService,
    cd: ChangeDetectorRef,
    private readonly authService: AuthService,
    private readonly injector: Injector,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly orgService: OrganizationService,
    private readonly dataService: InsightsDataService,
    private readonly auditLogsService: AuditLogsService,
    private readonly reportService: ReportManagerService,
    private readonly timeZoneService: TimeZoneService
  ) {
    super(cd);
    this.timeZone = this.timeZoneService.getUserTimeZone();
    this.loading$ = this.loaderService.loading$;
    this.authService.userData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.loggedInUserId = user?.id || 0;
      });
    this.feedbackForm = this.fb.group({});
    this.printForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      viewType: [1, Validators.required],
      isTrendLineEnabled: [false, Validators.required],
    });
    this.reportDetailForm = this.fb.group({
      reportTitle: ['', Validators.required],
      reportDescription: [
        '',
        [Validators.required, Validators.maxLength(2000)],
      ],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      viewType: [1, Validators.required],
      isTrendLineEnabled: [false],
      jobTypeId: [JobType.CaseFeedbackExport],
      entityId: [[], Validators.required],
    });
  }

  ngOnInit(): void {
    this.getDrawerParams();
    this.getExportedFeedbackReport();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setPrintLoading(itemId: string | number, isLoading: boolean): void {
    const currentState = this.printLoadingSubject.value;
    this.printLoadingSubject.next({
      ...currentState,
      [itemId]: isLoading,
    });
  }

  isPrintLoadingForItem(itemId: string | number): Observable<boolean> {
    return this.printLoading$.pipe(
      map((loadingState: Record<string, boolean>) => !!loadingState[itemId])
    );
  }

  getDrawerParams(): void {
    this.drawerService
      .getParams<FeedbackDrawerParams>(DRAWER_IDS.CASE_FEEDBACK)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.feedbackDetails = params;
          if (this.feedbackDetails.caseDetail) {
            this.isFeedBackEditable =
              this.feedbackDetails.caseDetail.isCaseFeedbackEditable || false;
            this.hasIncompleteFeedBack =
              this.feedbackDetails.caseDetail.isCaseFeedBackDue || false;
          }
        }
      });
  }

  onQueryParamsChange(params: NzTableQueryParams) {
    this.pageSize = params.pageSize;
    this.pageIndex = params.pageIndex;
    const currentSort = params.sort.find(item => item.value !== null);
    this.sort = currentSort?.key || 'organizationName';
    const sortValue = currentSort?.value;
    let sortOrderValue = 0;
    if (sortValue) {
      sortOrderValue = sortValue === 'ascend' ? 0 : 1;
    }
    this.sortOrder = sortOrderValue;
    this.loadData();
  }

  onCurrentReportPageDataChange(params: NzTableQueryParams) {
    this.reportPageSize = params.pageSize;
    this.reportPageIndex = params.pageIndex;
    const currentSort = params.sort.find(item => item.value !== null);
    this.reportSort = currentSort?.key || '';
    const sortDirection = currentSort?.value;
    if (sortDirection === 'ascend') {
      this.reportSortOrder = 0;
    } else if (sortDirection === 'descend') {
      this.reportSortOrder = 1;
    } else {
      this.reportSortOrder = undefined;
    }
    this.getExportedFeedbackReport();
  }
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedOrgId.push(id);
    } else {
      const index = this.setOfCheckedOrgId.indexOf(id);
      if (index !== -1) {
        this.setOfCheckedOrgId.splice(index, 1);
      }
    }
  }

  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);

    if (checked) {
      const item = this.listOfCurrentPageData.find(x => x.id === id);
      if (item && !this.selectedCase.some(c => c.id === id)) {
        this.selectedCase = [...this.selectedCase, item];
      }
    } else {
      this.selectedCase = this.selectedCase.filter(c => c.id !== id);
    }

    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    const eligibleItems = this.listOfCurrentPageData.filter(
      item => item.isAllQuestionsFeedbackSubmitted
    );
    for (const item of eligibleItems) {
      this.updateCheckedSet(item.id, value);
    }
    if (value) {
      const additions = eligibleItems.filter(
        item =>
          this.setOfCheckedOrgId.includes(item.id) &&
          !this.selectedCase.some(c => c.id === item.id)
      );
      if (additions.length) {
        this.selectedCase = [...this.selectedCase, ...additions];
      }
    } else {
      const currentPageIds = new Set(eligibleItems.map(i => i.id));
      this.selectedCase = this.selectedCase.filter(
        c => !currentPageIds.has(c.id)
      );
      this.setOfCheckedOrgId = [];
    }
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: readonly FeedBack[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checkedOrganization =
      this.listOfCurrentPageData.length > 0 &&
      this.listOfCurrentPageData.every(item =>
        this.setOfCheckedOrgId.includes(item.id)
      );
    this.indeterminate =
      this.listOfCurrentPageData.some(item =>
        this.setOfCheckedOrgId.includes(item.id)
      ) && !this.checkedOrganization;
  }
  loadData() {
    this.loaderService.show();
    this.feedbackService
      .getFeedBackList({
        Page: this.pageIndex,
        PageSize: this.pageSize,
        SortOrder: this.sortOrder,
        Sort: this.sort,
        caseId: this.feedbackDetails.caseId || 0,
      })
      .pipe(
        finalize(() => this.loaderService.hide()),
        takeUntil(this.destroy$)
      )
      .subscribe({
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
          this.cd.detectChanges();
        },
      });
  }

  submitFeedback(): void {
    this.viewFeedback({} as FeedBack, InsightMode.CREATE);
  }

  showExportDetailDialog(): void {
    this.reportDetailForm.reset({
      reportTitle: '',
      reportDescription: '',
      startDate: null,
      endDate: null,
      viewType: 1,
      isTrendLineEnabled: false,
      selectedTimeOption: null,
      entityId: this.setOfCheckedOrgId,
    });
    this.reportDetailForm.markAllAsTouched();
    this.reportDetailForm.updateValueAndValidity();
    this.isShowExportDetailDialog = true;
  }

  handleExportDetailClose(): void {
    this.isShowExportDetailDialog = false;
  }

  handleExportDetailConfirm(): void {
    if (!this.reportDetailForm.valid) {
      for (const key of Object.keys(this.reportDetailForm.controls)) {
        const control = this.reportDetailForm.get(key);
        control?.markAsTouched();
        control?.markAsDirty();
      }
      return;
    }

    this.isShowExportDetailDialog = false;
    this.exportFeedback();
  }

  openExportManagerDialog() {
    this.isShowExportManagerDialog = true;
    this.getExportedFeedbackReport();
  }

  handleExportManagerClose() {
    this.isShowExportManagerDialog = false;
    this.reportPageIndex = 1;
    this.reportPageSize = 10;
    this.getExportedFeedbackReport();
  }

  downloadReport(report: ExportedReportItem) {
    const jobId = report.jobId;

    if (!jobId) {
      this.commonService.notify('error', 'Report job ID not available');
      return;
    }

    this.loaderService.show();
    this.reportService
      .downloadReport(jobId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loaderService.hide())
      )
      .subscribe({
        next: response => {
          const blob = response.body;
          if (!blob) {
            this.commonService.notify('error', 'Failed to download report');
            return;
          }

          const fileName =
            this.extractFileNameFromHeader(
              response.headers.get('content-disposition')
            ) ||
            report.fileName ||
            'report';
          this.loaderService.hide();
          this.downloadBlob(blob, fileName);
        },
        error: (error: Error) => {
          this.loaderService.hide();
          this.commonService.notify(
            'error',
            error.message || 'Failed to download report'
          );
        },
      });
  }

  private extractFileNameFromHeader(
    contentDisposition: string | null
  ): string | null {
    if (!contentDisposition) {
      return null;
    }

    const utf8FileNamePattern = /filename\*=UTF-8''([^;]+)/i;
    const utf8FileNameMatch = utf8FileNamePattern.exec(contentDisposition);
    if (utf8FileNameMatch?.[1]) {
      return decodeURIComponent(utf8FileNameMatch[1]).replaceAll('"', '');
    }

    const simpleFileNamePattern = /filename="?([^";]+)"?/i;
    const simpleFileNameMatch = simpleFileNamePattern.exec(contentDisposition);
    if (simpleFileNameMatch?.[1]) {
      return simpleFileNameMatch[1];
    }

    return null;
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  getExportedFeedbackReport() {
    this.loaderService.show();
    this.reportService
      .getExportedProgressReport({
        page: this.reportPageIndex,
        pageSize: this.reportPageSize,
        sort: this.reportSort,
        sortOrder: this.reportSortOrder || undefined,
        jobTypeId: JobType.CaseFeedbackExport,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: res => {
          this.loaderService.hide();
          this.exportedReports = res.result.items || [];
          this.reportTotal = res.result.totalRows || 0;
        },
        error: (error: Error) => {
          this.loaderService.hide();
          this.exportedReports = [];
          this.commonService.notify('error', error.message);
        },
      });
  }

  getJobStatusText(statusId: number): string {
    const statusText = JobStatus[statusId] || '-';
    return statusText === JobStatus[3] ? 'Partial Success' : statusText;
  }

  getJobStatusClass(statusId: number): string {
    switch (statusId) {
      case JobStatus.Success:
        return 'active';
      case JobStatus.Pending:
        return 'pending';
      case JobStatus.PartiallySuccess:
        return 'updated';
      case JobStatus.Fail:
        return 'closed';
      default:
        return '';
    }
  }

  viewFeedback(item: FeedBack, mode = InsightMode.VIEW): void {
    if (mode !== InsightMode.CREATE && item.id) {
      this.fetchFeedbackData(item, mode);
    } else {
      this.openFeedbackDrawer(mode, item);
    }
  }

  onFilterChange(event: GraphFilterEvent) {
    this.patchGraphFilterToForm(this.printForm, event);
  }

  onExportFilterChange(event: GraphFilterEvent): void {
    this.patchGraphFilterToForm(this.reportDetailForm, event);
  }

  async manageBehvaiorGraphResponseData(
    data: BehaviorGraphDataResponse,
    selectedUnit: number,
    graphType: number,
    behaviorId: number
  ) {
    await this.processBehaviorGraphData(
      data,
      selectedUnit,
      graphType,
      this.printForm?.get('viewType')?.value,
      this.printForm?.get('isTrendLineEnabled')?.value || false,
      async (unit, graphData, showInterval) => {
        await this.generateImages(unit, graphData, showInterval, behaviorId);
      }
    );
  }

  async generateImages(
    selectedUnit: number,
    data:
      | frequencyDatasheetGraph
      | latencyGraph
      | partialIntervalGraph
      | replacementDataType
      | frequencyIntervalGraph,
    showIntervalFrequency = false,
    behaviorId?: number
  ) {
    const images = await this.feedBackService.generateGraphImage(
      this.viewContainerRef,
      selectedUnit,
      data,
      showIntervalFrequency
    );

    if (behaviorId && Number.isFinite(behaviorId) && behaviorId > 0) {
      const behaviorKey = String(behaviorId);
      this.graphImagesByBehaviorId[behaviorKey] = [
        ...(this.graphImagesByBehaviorId[behaviorKey] || []),
        ...images,
      ];
    }

    this.graphImages = [...this.graphImages, ...images];
  }

  showAdminNote(item: FeedBack) {
    this.isModalVisible = true;
    this.selectedFeedback = item;
  }

  fetchAdminNotes(item: FeedBack) {
    this.isAdminNotesModalVisible = true;
    this.isModalVisible = false;
    this.isNoteModalVisible = false;
    this.selectedFeedback = item;
    this.editingNote = null;
    this.loadAdminNotes(item.id);
  }

  private loadAdminNotes(feedbackId: number): void {
    this.loaderService.show();
    this.feedbackService
      .getAdminNotesByFeedbackId(feedbackId)
      .pipe(
        finalize(() => this.loaderService.hide()),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: response => {
          if (response?.result) {
            this.notes = response.result;
            this.editingNote = this.notes.find(n => n.isEditable) || null;
          } else {
            this.commonService.notify(
              'error',
              [response?.message || 'Failed to load notes'],
              'Error'
            );
          }
        },
        error: ({ errors, message }: ErrorResponse) => {
          const errorMessages = errors.map(
            err => err.description || err.detailedMessage
          );
          this.commonService.notify('error', errorMessages, message);
        },
      });
  }

  private initNoteForm(): void {
    this.noteForm = this.fb.group({
      comment: ['', [Validators.required, Validators.maxLength(2000)]],
    });
  }

  openNoteModal(): void {
    this.initNoteForm();
    this.noteForm.patchValue({
      comment: this.editingNote ? this.editingNote.comment : '',
    });
    this.isNoteModalVisible = true;
    this.isAdminNotesModalVisible = false;
    this.isModalVisible = false;
  }

  saveNote(): void {
    if (this.noteForm.invalid) return;

    const comment = this.noteForm.value.comment;
    this.isNoteSubmitting = true;

    this.feedbackService
      .submitAdminNoteByFeedbackId({
        noteId: this.editingNote?.id,
        feedbackId: this.selectedFeedback!.id,
        comment,
      })
      .pipe(
        finalize(() => (this.isNoteSubmitting = false)),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: response => {
          if (response) {
            const action = this.editingNote ? 'updated' : 'added';
            this.commonService.notify(
              'success',
              [`Note ${action} successfully`],
              'Success'
            );
            this.handleModalClose();
            this.loadAdminNotes(this.selectedFeedback!.id);
          } else {
            this.commonService.notify(
              'error',
              ['Failed to save note'],
              'Error'
            );
          }
        },
        error: ({ errors, message }: ErrorResponse) => {
          const errorMessages = errors.map(
            err => err.description || err.detailedMessage
          );
          this.commonService.notify('error', errorMessages, message);
        },
      });
  }

  async printFeedback() {
    try {
      this.setPrintLoading(this.selectedFeedback?.id || 0, true);
      this.graphImages = [];
      this.graphImagesByBehaviorId = {};
      const response = this.feedbackService
        .getCaseFeedbackReportData(
          this.selectedFeedback?.id || 0,
          this.feedbackDetails.student.organizationId || 0
        )
        .pipe(take(1), takeUntil(this.destroy$));
      const reportResponse = await firstValueFrom(response);
      if (reportResponse?.result) {
        this.reportData = reportResponse.result;
        this.setPrintLoading(this.selectedFeedback?.id || 0, true);
        if (this.reportData) {
          const behaviorIds = this.getBehaviorSpecificBehaviorIds(
            this.reportData
          );
          await this.getGraphDataInBatch(behaviorIds);
        }
        if (this.selectedFeedback) {
          await this.print(this.selectedFeedback);
        }
      } else {
        this.commonService.notify(
          'error',
          'Failed to load feedback report data'
        );
      }
    } catch (error) {
      console.error('Error fetching feedback report data:', error);
      this.setPrintLoading(this.selectedFeedback?.id || 0, false);
    }
  }

  private buildCaseBehaviorUnitMappings(
    behaviorIds: number[]
  ): caseBehaviorUnitMappings[] {
    const mappings: caseBehaviorUnitMappings[] = [];

    for (const behaviorId of behaviorIds) {
      for (const data of this.datasheetData) {
        const selectedUnit = data.id;

        mappings.push({
          caseBehaviorId: behaviorId,
          unitName: selectedUnit,
          graphType: 1,
        });

        if (selectedUnit === 1) {
          mappings.push({
            caseBehaviorId: behaviorId,
            unitName: selectedUnit,
            graphType: 2,
          });
        }
      }
    }

    return mappings;
  }

  private async getGraphDataInBatch(behaviorIds: number[]): Promise<void> {
    if (!behaviorIds.length) {
      return;
    }

    const startDate = this.printForm.get('startDate')?.value;
    const endDate = this.printForm.get('endDate')?.value;

    if (!startDate || !endDate) {
      return;
    }

    const mappings = this.buildCaseBehaviorUnitMappings(behaviorIds);
    if (!mappings.length) {
      return;
    }

    const response = this.dataService
      .getMultipleGraphData({
        caseBehaviorUnitMappings: mappings,
        startDate: format(startDate, DATE_FORMAT),
        endDate: format(endDate, DATE_FORMAT),
        viewType: this.printForm.get('viewType')?.value || 1,
      })
      .pipe(take(1), takeUntil(this.destroy$));
    const graphResponse = await firstValueFrom(response);

    if (graphResponse?.result?.caseBehaviorUnitMappings?.length) {
      await this.prepareGraphResponseData(
        graphResponse.result.caseBehaviorUnitMappings
      );
    }
  }

  private async prepareGraphResponseData(
    caseBehaviorUnitMappingsData: CaseBehaviorUnitMapping[]
  ): Promise<void> {
    const promises = caseBehaviorUnitMappingsData.map(async mapping => {
      const selectedUnit = this.resolveSelectedUnitFromMapping(mapping);

      if (!selectedUnit) {
        return;
      }

      await this.manageBatchGraphResponseData(mapping, selectedUnit);
    });

    await Promise.all(promises);
  }

  private resolveSelectedUnitFromMapping(
    mapping: CaseBehaviorUnitMapping
  ): { id: number; value: string } | undefined {
    if (mapping.graphType === 2) {
      return this.datasheetData.find(unit => unit.id === 1);
    }

    const numericUnitName = Number(mapping.unitName);
    if (Number.isFinite(numericUnitName) && numericUnitName > 0) {
      const byId = this.datasheetData.find(unit => unit.id === numericUnitName);
      if (byId) {
        return byId;
      }
    }

    const normalizedUnitName = String(mapping.unitName || '').toLowerCase();

    if (normalizedUnitName.includes('frequency')) {
      return this.datasheetData.find(unit => unit.id === 1);
    }
    if (normalizedUnitName.includes('latency')) {
      return this.datasheetData.find(unit => unit.id === 2);
    }
    if (normalizedUnitName.includes('partial')) {
      return this.datasheetData.find(unit => unit.id === 3);
    }
    if (normalizedUnitName.includes('replacement')) {
      return this.datasheetData.find(unit => unit.id === 4);
    }

    return undefined;
  }

  private async manageBatchGraphResponseData(
    caseBehaviorUnitMapping: CaseBehaviorUnitMapping,
    selectedUnit: { id: number; value: string }
  ): Promise<void> {
    const caseBehaviorId = caseBehaviorUnitMapping.caseBehaviorId;
    const graphType = caseBehaviorUnitMapping.graphType;
    const graphData = caseBehaviorUnitMapping.graph;

    const mappedData: BehaviorGraphDataResponse = {
      caseBehaviorId,
      unitName: selectedUnit.value,
      partialInterval:
        selectedUnit.id === 3 ? (graphData as partialIntervalGraph) : null,
      frequencyDuration:
        selectedUnit.id === 1 && graphType === 1
          ? (graphData as frequencyDatasheetGraph)
          : null,
      frequencyInterval:
        selectedUnit.id === 1 && graphType === 2
          ? (graphData as frequencyIntervalGraph)
          : null,
      latency: selectedUnit.id === 2 ? (graphData as latencyGraph) : null,
      replacementBehavior:
        selectedUnit.id === 4 ? (graphData as replacementDataType) : null,
    };

    await this.manageBehvaiorGraphResponseData(
      mappedData,
      selectedUnit.id,
      graphType,
      caseBehaviorId
    );
  }

  private getBehaviorSpecificBehaviorIds(
    reportData: CaseFeedBackReportResponse
  ): number[] {
    const behaviorSpecificQuestions = reportData.behaviorSpecificQuestions;

    if (!behaviorSpecificQuestions) {
      return [];
    }

    if (Array.isArray(behaviorSpecificQuestions)) {
      return Array.from(
        new Set(
          behaviorSpecificQuestions
            .map(question => question.caseBehaviorMappingId)
            .filter(id => Number.isFinite(id) && id > 0)
        )
      );
    }

    return Object.keys(behaviorSpecificQuestions)
      .map(Number)
      .filter(id => Number.isFinite(id) && id > 0);
  }

  async print(item: FeedBack) {
    const caseDetail = this.feedbackDetails.caseDetail;
    const factory = this.viewContainerRef.createComponent(
      PrintFeedbackComponent,
      {
        injector: this.injector,
      }
    );
    const componentElement = factory.location.nativeElement;
    componentElement.style.display = 'none';

    await firstValueFrom(
      this.orgService.getOrganization(caseDetail?.student.organizationId)
    )
      .then(async (orgRes: OrganizationModel | undefined) => {
        let base64Image = null;
        if (orgRes?.logoUrl) {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            orgRes.logoUrl
          );
        } else {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            '/assets/images/logo.png'
          );
        }
        factory.instance.feedbackData = {
          logo: base64Image,
          caseDetail: caseDetail,
          orgDetail: orgRes,
          feedbackDetail: this.reportData || null,
          graphImages: this.graphImages,
          graphImagesByBehaviorId: this.graphImagesByBehaviorId,
        } as PrintFeedBack;
        this.waitForInitialization(factory).then(async () => {
          try {
            await factory.instance.printPDF();
            this.logFeedbackPrintAudit(item);
            factory.destroy();
            this.commonService.notify(
              'success',
              'Feedback Report has been printed successfully'
            );
            this.setPrintLoading(item.id, false);
            this.graphImages = [];
            this.graphImagesByBehaviorId = {};
            this.cd.markForCheck();
          } catch {
            this.logFeedbackPrintFailureAudit(item);
            factory.destroy();
            this.commonService.notify('error', 'Error generating PDF');
            this.setPrintLoading(item.id, false);
            this.graphImages = [];
            this.graphImagesByBehaviorId = {};
            this.cd.markForCheck();
          }
        });
      })
      .catch(e => {
        console.error(e);
        this.setPrintLoading(item.id, false);
        this.graphImages = [];
        this.graphImagesByBehaviorId = {};
        this.cd.markForCheck();
      })
      .finally(() => {
        this.setPrintLoading(item.id, false);
        this.isModalVisible = false;
      });
  }

  private logFeedbackPrintAudit(item: FeedBack): void {
    const firstName = item.caseMemberUserFirstName || '';
    const lastName = item.caseMemberUserLastName || '';
    const memberName = `${firstName} ${lastName}`.trim() || 'Unknown User';

    this.auditLogsService
      .logAudit({
        auditModule: AuditModule.CaseFeedback,
        auditOperationType: AuditOperationType.Printed,
        entityType: 'CaseFeedback',
        summary: `Feedback for ${memberName} printed`,
        caseId: this.feedbackDetails.caseId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: ({ errors, message }: ErrorResponse) => {
          const errorMessages = errors.map(
            err => err.description || err.detailedMessage
          );
          console.error(
            'Error logging feedback print audit:',
            message,
            errorMessages
          );
        },
      });
  }

  private logFeedbackPrintFailureAudit(item: FeedBack): void {
    const firstName = item.caseMemberUserFirstName || '';
    const lastName = item.caseMemberUserLastName || '';
    const memberName = `${firstName} ${lastName}`.trim() || 'Unknown User';

    this.auditLogsService
      .logAudit({
        auditModule: AuditModule.CaseFeedback,
        auditOperationType: AuditOperationType.Printed,
        entityType: 'CaseFeedback',
        summary: `Feedback for ${memberName} is failed to print`,
        caseId: this.feedbackDetails.caseId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: ({ errors, message }: ErrorResponse) => {
          const errorMessages = errors.map(
            err => err.description || err.detailedMessage
          );
          console.error(
            'Error logging feedback print failure audit:',
            message,
            errorMessages
          );
        },
      });
  }

  waitForInitialization(factory: ComponentRef<PrintFeedbackComponent>) {
    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (factory.instance.initialized) {
          clearInterval(interval);
          resolve();
        }
      }, 10);
    });
  }
  private fetchFeedbackData(item: FeedBack, mode: InsightMode): void {
    this.loaderService.show();
    this.feedbackService
      .getFeedbackByCaseId(item.id)
      .pipe(
        finalize(() => this.loaderService.hide()),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: response => {
          if (response.result) {
            this.openFeedbackDrawer(mode, response.result);
          } else {
            this.commonService.notify('error', 'Failed to load feedback data');
          }
        },
        error: error => {
          console.error('Error fetching feedback data:', error);
        },
      });
  }

  private openFeedbackDrawer(
    mode: InsightMode,
    data: FeedBack | FeedBackByCase
  ): void {
    this.drawerService
      .openDrawer(
        FeedbackFormComponent,
        this.viewFeedbackFormTpl as unknown as TemplateRef<object>,
        1170,
        true,
        undefined,
        {
          mode,
          data: data,
          student: this.feedbackDetails.student,
          caseId: this.feedbackDetails.caseId,
          supervisorName: this.feedbackDetails.supervisorName,
          caseDetail: this.feedbackDetails.caseDetail,
        },
        DRAWER_IDS.FEEDBACK_FORM
      )
      .afterClose.pipe(take(1), takeUntil(this.destroy$))
      .subscribe(() => {
        this.loadData();
      });
  }

  closeFeedBackFormDrawer() {
    this.drawerService.closeDrawer(DRAWER_IDS.FEEDBACK_FORM);
  }

  handleModalClose() {
    this.isModalVisible = false;
    this.isAdminNotesModalVisible = false;
    this.isNoteModalVisible = false;
  }

  private patchGraphFilterToForm(
    targetForm: FormGroup,
    event: GraphFilterEvent
  ): void {
    targetForm.patchValue({
      viewType: event.viewType,
      isTrendLineEnabled: event.isTrendLineEnabled,
      startDate: parse(event.startDate, DATE_FORMAT, new Date()),
      endDate: parse(event.endDate, DATE_FORMAT, new Date()),
    });
  }

  private exportFeedback(): void {
    const caseId = this.feedbackDetails.caseId;
    if (!caseId) {
      this.commonService.notify('error', 'Case is not available for export');
      return;
    }

    const payload = {
      reportTitle: this.reportDetailForm.value.reportTitle,
      reportDescription: this.reportDetailForm.value.reportDescription,
      entityId: this.setOfCheckedOrgId,
      timeZoneId: this.timeZone,
      jobTypeId: JobType.CaseFeedbackExport,
      filters: {
        startDate: format(this.reportDetailForm.value.startDate, DATE_FORMAT),
        endDate: format(this.reportDetailForm.value.endDate, DATE_FORMAT),
        viewType: this.reportDetailForm.value.viewType,
        isTrendLineEnabled: this.reportDetailForm.value.isTrendLineEnabled,
      },
    };

    this.loaderService.show();
    this.reportService
      .generateReport(payload)
      .pipe(
        finalize(() => this.loaderService.hide()),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: () => {
          this.commonService.notify(
            'success',
            'Feedback export initiated successfully'
          );
          this.setOfCheckedOrgId = [];
          this.indeterminate = false;
          this.checkedOrganization = false;
          this.getExportedFeedbackReport();
        },
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
        },
      });
  }
}
